export const SET_TEAM = "SET_TEAM";
export const GET_TEAM = "GET_TEAM";
export const SET_PROJECT = "SET_PROJECT";
export const GET_PROJECT = "GET_PROJECT";
